/**
 * Shim for Object.entries and Array.entries
 * @param {Array|Object} obj - The array or object to get the entries for
 * @returns {Array} - [[index, value], ...] for arrays, [[key, value], ...] for objects.
 */
export const esEntries = (obj) => {
    // check for Array first as arrays are also instances of Object
    if (obj instanceof Array) {
        return obj.reduce((acc, val, idx) => acc.concat([[idx, val]]), []);
    } if (obj instanceof Object) {
        return Object.keys(obj).reduce((acc, val) => acc.concat([[val, obj[val]]]), []);
    }
    throw Error(`Unsupported type supplied to esEntries: ${typeof obj}`);
};
